import React from 'react';
import PropTypes from 'prop-types';

import Select from 'common/components/select';
import DashboardActionsMenu from 'common/components/dashboard-actions-menu';
import DashboardActionsIconBox from 'common/components/dashboard-actions-icon-box';

import ReportsDashboardStore from 'common/stores/reports-dashboard-store';

import {t} from 'common/utils/translation-util';
import './index.scss';

// NOTE: This component is dependent upon the ReportsDashboardStore being
// updated with api data (from /reports). This component is used on the homepage,
// building home, and tenant home pages, where a sibling Dashboard component
// makes the api call.
export default class DashboardSwitcher extends React.Component {
  static propTypes = {
    currentDashboard: PropTypes.object.isRequired,
    dashboards: PropTypes.object.isRequired,
    setDashboard: PropTypes.func.isRequired,
    userCanEditDashboard: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onReportsDashboardStoreUpdate =
      this.onReportsDashboardStoreUpdate.bind(this);
  }

  state = {};

  componentDidMount() {
    ReportsDashboardStore.addChangeListener(this.onReportsDashboardStoreUpdate);
  }

  componentWillUnmount() {
    ReportsDashboardStore.removeChangeListener(
      this.onReportsDashboardStoreUpdate,
    );
  }

  getSelectOptions(dashboards) {
    const defaultDashboards = [];
    const customDashboards = [];

    for (const dashboardId of Object.keys(dashboards)) {
      const dashboard = dashboards[dashboardId];
      const option = {
        group: dashboard.default
          ? t('Standard dashboards')
          : t('Custom dashboards'),
        label: dashboard.name,
        value: Number(dashboardId),
      };
      if (dashboard.default) {
        defaultDashboards.push(option);
      } else {
        customDashboards.push(option);
      }
    }

    const groupActions = [
      {
        group: 'Actions',
        label: t('Add a dashboard'),
        iconName: 'add',
        value: -1,
      },
    ];

    defaultDashboards.sort((first, second) =>
      first.label.localeCompare(second.label),
    );
    customDashboards.sort((first, second) =>
      first.label.localeCompare(second.label),
    );

    return [].concat(defaultDashboards, customDashboards, groupActions);
  }

  render() {
    const {currentDashboard, dashboards, userCanEditDashboard} = this.props;

    const {currentDashboardName} = this.state;

    // Show actions menu if a) not viewing a default dashboard; and
    // B) the ReportsDashboardStore has been updated with api data
    const showActionsMenu = currentDashboard.id && currentDashboardName;

    const options = this.getSelectOptions(dashboards);
    const value = currentDashboard.id || 0;

    return (
      <div className={'clearfix DashboardSwitcherBox'}>
        <span className={'DashboardSwitcher'}>
          <span>{t('Dashboard:')}</span>
          <Select
            closeAfterSelection={true}
            onChange={this.onChange}
            options={options}
            showGroupLabels={true}
            showSearch={true}
            value={value}
          />
        </span>
        {showActionsMenu && (
          <div className={'DashboardActionsBox'}>
            <span className={'DashboardSwitcher-DashboardActionsIconBox'}>
              <DashboardActionsIconBox dashboard={currentDashboard} />
            </span>
            <span className={'DashboardSwitcher-DashboardActionsMenu'}>
              <DashboardActionsMenu
                className={'Button Button--menu'}
                dashboard={currentDashboard}
                triggerLabel={t('Actions')}
                userCanEditDashboard={userCanEditDashboard}
              />
            </span>
          </div>
        )}
      </div>
    );
  }

  onChange(newValue) {
    this.props.setDashboard(newValue);
  }

  onReportsDashboardStoreUpdate() {
    const meta = ReportsDashboardStore.getMeta();

    this.setState({
      currentDashboardName: meta.name,
    });
  }
}
